import React from "react";
import onClickOutside from "react-onclickoutside";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { KeyboardArrowDown, KeyboardArrowUp } from "components/Icons";
import "./SettingsMenu.scss";

interface IProps {
  profileName: string;
  withIcon?: boolean;
  items: any[];
}

interface IState {
  expanded: boolean;
}

class SettingsMenu extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);

    this.state = { expanded: false };
  }

  /**
   * Called by 'react-onclickoutside' when clicked outside the Header component
   */
  public handleClickOutside = () => {
    this.setState({ expanded: false });
  };

  public render() {
    const { profileName, items, withIcon } = this.props;

    return (
      <div
        className={classNames("settings-menu", { "with-icon": withIcon })}
        onClick={() => this.setState({ expanded: !this.state.expanded })}
      >
        <div className="profile-info">
          {profileName} <KeyboardArrowDown />
        </div>

        {this.state.expanded && (
          <div
            className="profile-menu"
            onClick={() => this.setState({ expanded: !this.state.expanded })}
          >
            <ul>
              <li>
                <div
                  className={classNames("account-menu", {
                    "with-icon": withIcon
                  })}
                >
                  {withIcon && <div className="profile-icon">VH</div>}
                  <div className="profile-info">
                    {profileName} <KeyboardArrowUp />
                  </div>
                </div>
              </li>
              {items.map(
                (item, i) =>
                  !item.hidden && (
                    <li key={i}>
                      <Link to={item.url || "#"} onClick={item.onClick}>
                        {item.renderIcon()}
                        <FormattedMessage id={item.name} tagName="span" />
                      </Link>
                    </li>
                  )
              )}
            </ul>
          </div>
        )}
      </div>
    );
  }
}

export default onClickOutside(SettingsMenu);
